import apiClient from "./apiClient";

export interface LegalContent {
  id: number;
  type: string;
  frContent: string;
  enContent: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateLegalContentData {
  type: string;
  frContent: string;
  enContent: string;
}

export interface UpdateLegalContentData {
  frContent?: string;
  enContent?: string;
  isActive?: boolean;
}

class LegalContentService {
  async getAllLegalContents(): Promise<LegalContent[]> {
    const response = await apiClient.get("/api/legal-contents");
    return response.data;
  }

  async getLegalContentByType(type: string): Promise<LegalContent> {
    const response = await apiClient.get(`/api/legal-contents/${type}`);
    return response.data;
  }

  async createLegalContent(
    data: CreateLegalContentData,
  ): Promise<LegalContent> {
    const response = await apiClient.post("/api/legal-contents", data);
    return response.data;
  }

  async updateLegalContent(
    id: number,
    data: UpdateLegalContentData,
  ): Promise<LegalContent> {
    const response = await apiClient.put(`/api/legal-contents/${id}`, data);
    return response.data;
  }

  async deleteLegalContent(id: number): Promise<void> {
    await apiClient.delete(`/api/legal-contents/${id}`);
  }
}

export default new LegalContentService();
